import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import whatInput from 'what-input';
import ColorSwatch from '@moncler/components/product/ColorSwatch';
import useBreakpoint from '@utils/useBreakpoint';
const Selector = (props) => {
    var _a, _b;
    const { t } = useTranslation();
    const selectorRef = useRef(null);
    const buttonRef = useRef(null);
    const menuRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [hovering, setHovering] = useState(false);
    const [focusList, setFocusList] = useState(false);
    const currentBreakpoint = useBreakpoint();
    const currentValue = useRef(props.currentItem);
    useEffect(() => {
        if (props.forceCloseOnChange && currentValue.current !== props.currentItem && whatInput.ask() === 'mouse') {
            setOpen(false);
            setHovering(false);
        }
        currentValue.current = props.currentItem;
    }, [props.currentItem]);
    useEffect(() => {
        const selectorButton = buttonRef.current;
        const setButtonWidth = () => {
            if (selectorButton && props.enableOnlyOneLeftLabel) {
                if (currentBreakpoint < window.mqObj.sm) {
                    selectorButton.classList.add('selector__button__mobile');
                    const viewportWidth = window.innerWidth;
                    const dynamicWidth = `${viewportWidth * 0.35 + 15}px`; // Calcola la larghezza dinamica in base alla viewport
                    selectorButton.style.width = dynamicWidth;
                }
                else {
                    selectorButton.classList.remove('selector__button__mobile');
                    // Resetta la larghezza
                    selectorButton.style.width = '';
                }
            }
        };
        // Esegue la funzione quando la finestra viene ridimensionata
        window.addEventListener('resize', setButtonWidth);
        setButtonWidth();
        // Rimuove il listener quando il componente viene smontato
        return () => {
            window.removeEventListener('resize', setButtonWidth);
        };
    }, [currentBreakpoint]);
    useEffect(() => {
        var _a, _b, _c;
        if (open) {
            props.trackOpen ? props.trackOpen() : null;
            const menuHeight = (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight;
            if (selectorRef.current && menuHeight > selectorRef.current.offsetHeight) {
                selectorRef.current.style.height = `${menuHeight}px`;
            }
            if (whatInput.ask() === 'keyboard') {
                (_b = menuRef.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
        }
        else {
            (_c = selectorRef.current) === null || _c === void 0 ? void 0 : _c.removeAttribute('style');
        }
    }, [open]);
    useEffect(() => {
        /*     if (open && !props.open) setTimeout(() => buttonRef.current.focus(), 0);
         */
        !hovering && setOpen(props.open);
    }, [props.open, props.currentItem]);
    const enableOutofstockClass = useMemo(() => {
        var _a;
        let enabled = false;
        if (props.enableOutofstockLabel && !props.swatchable && !((_a = props.currentItem) === null || _a === void 0 ? void 0 : _a.selectable)) {
            enabled = true;
        }
        if (props.stockStatus) {
            if (props.stockStatus === 'PRODUCT__OOS' || props.stockStatus === 'SIZE__OOS') {
                enabled = true;
            }
        }
        return enabled;
    }, [props.enableOutofstockLabel, props.swatchable, props.currentItem, props.stockStatus]);
    const onMouseEnterHandler = () => {
        if (whatInput.ask() === 'mouse' && !props.disableHover && props.children.length !== 1) {
            setOpen(true);
            setHovering(true);
        }
    };
    const onMouseLeaveHandler = () => {
        if (whatInput.ask() === 'mouse' && !props.disableHover && !props.open && props.children.length !== 1) {
            setOpen(false);
            setHovering(false);
        }
    };
    return (React.createElement("div", { className: classNames(props.className), ref: selectorRef },
        React.createElement("button", { type: "button", ref: buttonRef, "aria-controls": props.selectorId, onMouseEnter: onMouseEnterHandler, onMouseLeave: onMouseLeaveHandler, onClick: () => {
                setOpen(!open);
                props.onClickExtraAction && props.onClickExtraAction(true);
            }, className: classNames('selector__button', { expanded: props.open || open }), disabled: props.children.length === 1 }, props.currentItem ? (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "selector__button__label" }, props.selectedLabel + ' '),
            !props.hideValue && (React.createElement("span", { className: classNames('selector__button__value', enableOutofstockClass && 'selector__button__value--outofstock') }, props.itemType === 'string' ? props.currentItem : (_a = props.currentItem) === null || _a === void 0 ? void 0 : _a.displayValue)),
            props.itemType === 'object' && props.swatchable && React.createElement(ColorSwatch, { variation: props.currentItem, ariaHidden: true }),
            React.createElement("span", { className: "visually-hidden" }, t('exchanges.changecolor')),
            props.enableOutofstockLabel && !props.swatchable && !props.currentItem.selectable && React.createElement("span", { className: "selector__button__info" }, t('label.outofstock')),
            props.enableOnlyOneLeftLabel && React.createElement("span", { className: "selector__button__info" }, t('bag.onlyoneleft')))) : (React.createElement(React.Fragment, null,
            React.createElement("span", null, (props === null || props === void 0 ? void 0 : props.hideUnselectedLabel) ? props.selectedLabel : props === null || props === void 0 ? void 0 : props.unselectedLabel),
            (props === null || props === void 0 ? void 0 : props.hideUnselectedLabel) && props.stockStatus === 'PRODUCT__OOS' && !props.swatchable && (React.createElement("span", { className: "selector__button__info outofstock--all" }, t('label.outofstock'))),
            React.createElement(AnimatePresence, null, props.error && (React.createElement(motion.span, { className: "errormessage", transition: { ease: [0.25, 1, 0.5, 1], duration: 0.166 }, initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, role: "alert" }, props.error)))))),
        React.createElement("div", { ref: menuRef, className: classNames('selector__menu'), id: props.selectorId, "aria-labelledby": props.selectorId + '-title', tabIndex: -1, onMouseEnter: onMouseEnterHandler, onMouseLeave: onMouseLeaveHandler, onBlur: (e) => {
                // wishlist - focus on selector button after selecting a size [OE-22970]
                if (!open) {
                    const selectorButton = e.currentTarget.parentNode.childNodes[0];
                    if (selectorButton && selectorButton.classList.contains('selector__button')) {
                        selectorButton.focus();
                    }
                }
            } },
            React.createElement("span", { className: "label", id: props.selectorId + '-title', "aria-hidden": "true" }, (_b = props.selectLabel) !== null && _b !== void 0 ? _b : props.selectedLabel,
                ":"),
            React.createElement("div", { className: classNames(focusList ? 'focused' : '', 'selector-wrapper'), onFocus: () => {
                    // handles color labels show/hide on keyboard focus
                    setFocusList(true);
                }, onBlur: () => {
                    // handles color labels show/hide on keyboard focus
                    setFocusList(false);
                } },
                React.createElement("fieldset", { className: "selector__menu--size--radio-btn" }, props.children)))));
};
Selector.defaultProps = {
    swatchable: false,
    enableOutofstockLabel: false,
    hideValue: false,
    itemType: 'object',
};
export default Selector;
